"use client"

import { useEffect, useState } from "react"
import { createPopupPortal } from "./PopupPortal"
import { useGlobalPopupStore } from "./store/useGlobalPopupStore"

export default function GlobalPopupPortal() {
  const elementId = "overlay-global-popup-root"
  const { isOpen, content, closePopup } = useGlobalPopupStore()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : ""
    return () => {
      document.body.style.overflow = ""
    }
  }, [isOpen])

  if (!mounted) return null

  const overlayRoot = document.getElementById(elementId)

  if (!overlayRoot) return null

  return createPopupPortal({
    elementId,
    isOpen,
    position: null,
    children: content,
    onClose: closePopup,
  })
}
